import React from "react";
import { Box } from "fds";
import classNames from "classnames";
import "./index.scss";
interface RevisionTagProps {
  revisionNo?: number;
  size?: "sm" | "md";
  classes?: string;
  style?: React.CSSProperties;
}
const RevisionTag: React.FC<RevisionTagProps> = ({
  revisionNo,
  size = "sm",
  style,
  classes,
}) => {
  return (
    <Box
      classes={classNames("revisionTag", size, classes)}
      style={{ ...style }}
    >
      v{revisionNo ?? 0}
    </Box>
  );
};
export default RevisionTag;
